<ng-template #loading>
    <div class="m-loader m-loader--brand pb-5 text-center"></div>
</ng-template>
<div class="m-portlet mb-2" [ngClass]="{ 'border-danger border': termItemForm?.invalid }">
    <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
                <div class="m-portlet__head-text">
                    <i ngbTooltip="Termin" container="body" class="la la-calendar-check-o"></i>
                    <span *ngIf="!formData?.isDetailsOpend" class="m--font-bold">
                        {{ termItemForm?.value?.selectedDate | date: 'dd.MM.yyyy' }}, [{{ termItemForm?.value?.selectedTime }} -
                        {{ termItemForm?.value?.selectedTimeEnd }}],
                        {{ termItemForm?.value?.selectedSubcontractor?.name }}
                    </span>
                </div>
            </div>
        </div>
        <div class="m-portlet__head-tools">
            <trt-wid-m-term-head [formData]="termItemForm.value" (onClosePopup)="onClosePopup.emit()"></trt-wid-m-term-head>
        </div>
    </div>
    <div *ngIf="formData?.isDetailsOpend" class="m-portlet__body">
        <form *ngIf="termItemForm; else loading" [formGroup]="termItemForm" novalidate>
            <div class="row m-row--no-padding">
                <div class="col-lg-3 d-flex">
                    <i
                        ngbTooltip="Izvajalec storitve"
                        class="la la-stethoscope m--font-inverse-light mt-2 mr-2"
                        i18n-ngbTooltip="@@53071fadc2548c8e8de41b3421d229d712e9a44f"
                    ></i>

                    <ng-select
                        [items]="allSubcontractors"
                        (change)="onSubConctractorChange($event)"
                        bindLabel="name"
                        tabindex="2"
                        formControlName="selectedSubcontractor"
                        class="w-100"
                    >
                        <ng-template ng-optgroup-tmp let-item="item">
                            {{ item.name }}
                        </ng-template>
                    </ng-select>
                </div>

                <div class="col-lg-3 d-flex">
                    <i
                        ngbTooltip="Nosilna storitev"
                        class="la la-hand-paper-o m--font-inverse-light mt-2 mx-2"
                        i18n-ngbTooltip="@@62d6803396ae2c32c9b7855af7812186913ca0f7"
                    ></i>

                    <ng-select
                        [items]="servicesForSubconstractor"
                        [compareWith]="equalsAnyById"
                        (change)="onServiceChange()"
                        bindLabel="name"
                        tabindex="3"
                        groupBy="type"
                        formControlName="selectedService"
                        class="w-100"
                    >
                        <ng-template ng-optgroup-tmp let-item="item">
                            {{ item.type | serviceTypePipe }}
                        </ng-template>
                    </ng-select>
                </div>

                <div class="col-lg-3 d-flex">
                    <i ngbTooltip="Prostor izvedbe" class="la la-sign-in m--font-inverse-light mt-2 mx-2"></i>
                    <select
                        [compareWith]="equalsAnyById"
                        (change)="setFormNotChecked()"
                        formControlName="selectedAsset"
                        class="form-control m-input"
                        [ngClass]="{ 'border-danger border': (termItemForm?.controls)['selectedAsset'].errors }"
                    >
                        <option></option>
                        <optgroup *ngFor="let group of assetGroups" label="{{ group.label }}">
                            <option *ngFor="let asset of group.data" [ngValue]="asset">
                                {{ asset.name }}
                            </option>
                        </optgroup>
                    </select>
                </div>

                <div class="col-lg-3 d-flex">
                    <i
                        ngbTooltip="Posebna oznaka"
                        class="la la-star mt-2 mx-2"
                        [ngClass]="(termItemForm?.controls)['customTagId']?.value?.classColor || 'mf-custom-tag'"
                        i18n-ngbTooltip="@@3cd2ad7b8e6ba51d2ebb3fadbbabe78f42525c9a"
                    ></i>
                    <select [compareWith]="equalsAnyById" (change)="setFormNotChecked()" formControlName="customTagId" class="form-control m-input">
                        <option *ngFor="let tag of customTags" [ngValue]="tag.id">
                            {{ tag.name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row m-row--no-padding mt-2">
                <div class="col-lg-3 d-flex">
                    <i ngbTooltip="Datum termina" class="la la-calendar m--font-inverse-light mt-2 mr-2"></i>
                    <input
                        [options]="calendarOptions"
                        (selected)="setDate($event)"
                        type="text"
                        name="daterangeInput"
                        daterangepicker
                        formControlName="selectedDateView"
                        class="form-control m-input"
                    />
                </div>

                <div class="col-lg-3 d-flex">
                    <i ngbTooltip="Ura pričeteka termina" class="la la-clock-o m--font-inverse-light mt-2 mx-2"></i>
                    <input
                        [textMask]="{ mask: timeInputMask, keepCharPositions: true }"
                        (keyup)="onStartTimeChange()"
                        type="text"
                        placeholder="hh:mm"
                        formControlName="selectedTime"
                        class="form-control m-input"
                        [ngClass]="{ 'border-danger border': (termItemForm?.controls)['selectedTime'].errors }"
                    />
                </div>

                <div class="col-lg-3 d-flex">
                    <i ngbTooltip="Ura konca termina" class="la la-step-forward m--font-inverse-light mt-2 mx-2"></i>
                    <input
                        [textMask]="{ mask: timeInputMask, keepCharPositions: true }"
                        (keyup)="setFormNotChecked()"
                        type="text"
                        placeholder="hh:mm"
                        formControlName="selectedTimeEnd"
                        class="form-control m-input"
                        [ngClass]="{ 'border-danger border': (termItemForm?.controls)['selectedTimeEnd'].errors }"
                    />
                </div>
            </div>
            <div *ngIf="formData?.availabilityStatus == availabilityStatus.OCCUPIED" class="row m-row--no-padding mt-2">
                <span class="">Prvi prosti termin:</span>
                <span
                    *ngFor="let slot of formData?.freeSlots"
                    (click)="selectFreeSlot(slot)"
                    class="m-badge m-badge--success m-badge--wide mf-darken-hover mf-cursor-pointer ml-2"
                >
                    {{ slot?.start | date: 'dd.MM.yyyy' }}
                    <span class="font-weight-bold">
                        {{ slot?.start | date: 'HH:mm' }} -
                        {{ slot?.end | date: 'HH:mm' }}
                    </span>
                </span>
            </div>
        </form>
    </div>
</div>
